export default __webpack_public_path__ + "static/media/noun_dental care_2692540.eaba5502.png";